import { render } from "./EditSortiePage.vue?vue&type=template&id=385d43f2&ts=true"
import script from "./EditSortiePage.vue?vue&type=script&lang=ts"
export * from "./EditSortiePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__